import { type App, Plugin } from "vue";
import AppHeader from "./global/app-header.vue";
import AppMainView from "./global/app-main-view.vue";
import AppFooter from "./global/app-footer.vue";
import AppMainSidebar from "./global/app-main-sidebar.vue";
import AppSecondarySidebar from "./global/app-secondary-sidebar.vue";
import AppOverlay from "./global/app-overlay.vue";

/**
 * Register global components
 */
export const GlobalComponentsPlugin: Plugin = {
    install(app: App) {
        app.component("AppHeader", AppHeader);
        app.component("AppMain", AppMainView);
        app.component("AppFooter", AppFooter);
        app.component("AppSidebar", AppMainSidebar);
        app.component("AppSecondarySidebar", AppSecondarySidebar);
        app.component("AppOverlay", AppOverlay);
    },
};

export { AppHeader };